var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('item-detail',{key:index,staticClass:"form-check form-check-inline",attrs:{"data":item,"is-mobile":_vm.isMobile,"user":_vm.user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }